import { AWS_BASE_URL } from "../../clientConfig";
import { USER_ROUTES } from "../../constants/appRoutes";

const ErrorPage = () => {
  return (
    <div className="h-dvh w-screen fixed top-0 left-0 overflow-hidden flex justify-center items-center">
      <div className="container grid grid-cols-1 lg:grid-cols-2 items-center">
        <div className="space-y-4 w-3/4">
          <h1 className="text-5xl font-bold text-ocean-teal">Ooops!!</h1>
          <h6 className="text-3xl font-bold text-steel-blue">
            Something went wrong
          </h6>
          <p className="text-xl font-medium text-Blue-Lagoon lowercase">
            It seems that the page you are looking for is currently unavailable
            or has encountered an error.
          </p>
          <p className="text-xl font-medium text-Blue-Lagoon lowercase">
            We apologize for the inconvenience and appreciate your
            understanding.
          </p>
          <div className="flex justify-start items-center gap-x-3">
            <a
              href={USER_ROUTES.ROOT}
              className="p-2 border-b-2 border-black hover:border-ocean-teal hover:text-ocean-teal text-lg font-semibold"
              rel="noopener noreferrer"
            >
              Homepage
            </a>
            <a
              href={USER_ROUTES.CONTACT_US}
              className="p-2 border-b-2 border-black hover:border-ocean-teal hover:text-ocean-teal text-lg font-semibold"
              rel="noopener noreferrer"
            >
              Contact Support
            </a>
            <a
              href={USER_ROUTES.BLOG_LIST}
              className="p-2 border-b-2 border-black hover:border-ocean-teal hover:text-ocean-teal text-lg font-semibold"
              rel="noopener noreferrer"
            >
              Read Blog
            </a>
          </div>
        </div>
        <div>
          <img
            src={`${AWS_BASE_URL}development/images/blogImages/images-1731394754082-816071139.png`}
            alt="page not found"
            className="w-full h-full"
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
